
import { createMultiStyleConfigHelpers, switchAnatomy } from "~/foundation/Chakra";

const { definePartsStyle, defineMultiStyleConfig } = createMultiStyleConfigHelpers(switchAnatomy.keys);

const baseStyle = definePartsStyle({
	container: {
		backgroundColor: "transparent",
	},
	track: {
		bgColor: "transparent",
		borderRadius: "full",
		width: "24px",
		height: "16px",
		borderWidth: "2px",
		borderFill: "solid",
		boxSizing: "border-box",
		borderColor: "currentColor",
	},
	thumb: {
		borderRadius: "full",
		height: "14px",
		width: "14px",
		position: "absolute",
		top: "1px",
		left: "1px",
		transition: "transform linear 250ms",
		backgroundColor: "currentColor",
		_checked: {
			transform: `translateX(8px)`,
		}
	},
});

export const Switch = defineMultiStyleConfig({ baseStyle });
